// MD2 PRO
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

// Components
import FileViewGoogleDrive from 'components/General/File/FileViewGoogleDrive';
import SummaryCard from 'layouts/production/Components/AaroComponents/SummaryCard';

// Helpers
import { formatPrice } from 'helpers/priceHelpers';
import { formatDate } from 'helpers/dateHelpers';

// Constants
import { config } from 'Constants';

const { GOOGLE_DRIVE_CONTRACT_FILES_FOLDER_ID } = config.fixedID;

function SidebarRight({ production, relatedID, aaroQueries }) {
    // Guard clause to prevent errors when production data isn't available
    if (!production) {
        return null;
    }

    const { contractQuery } = aaroQueries;
    const contractDetails = contractQuery?.data?.[0] || {};

    const {
        SozlesmeAdi: SozlesmeAdiContract,
        SozlesmeID: SozlesmeIDContract,
        Tutar: SozlesmeTutari,
        TutarDvz: SozlesmeTutariDVZ,
        DovizKodu: SozlesmeDovizKodu,
        OlsTar: SozlesmeOlusturulmaTarihi,
        CariAdi,
        CariID: SozlesmeCariID,
        OlsAdi: SozlesmeyiOlusturanAdi,
        TipAdi: SozlesmeTipAdi,
        TarihBit,
    } = contractDetails;

    // Calculate how many days ago the order was created

    const daysContractCreated = Math.floor((new Date() - new Date(SozlesmeOlusturulmaTarihi)) / (1000 * 60 * 60 * 24));

    const getURL = (type, id, name) => {
        const url = `https://erp.aaro.com.tr/${type}?id=${id}`;
        return (
            <a href={url} target="_blank" rel="noreferrer">
                {name}
            </a>
        );
    };

    // Helper function to render contract details section
    const renderContractDetails = () => {
        if (!SozlesmeIDContract) return null;
        return (
            <SummaryCard
                title="Sözleşme Özeti"
                subtitle={` ${daysContractCreated} gün önce, ${SozlesmeyiOlusturanAdi} tarafından oluşturuldu.`}
                truncateValues={true}
                items={{
                    Sözleşme: getURL('Sozlesme/Kalem', SozlesmeIDContract, SozlesmeAdiContract),
                    Müşteri: getURL('Cari/Ozet', SozlesmeCariID, CariAdi),
                    Tutar: `${formatPrice(SozlesmeTutari || 0)}`,
                    'Tutar Döviz': `${formatPrice(SozlesmeTutariDVZ || 0, SozlesmeDovizKodu)}`,
                    Tipi: SozlesmeTipAdi,
                    Bitiş: formatDate(TarihBit),
                    Tarih: formatDate(SozlesmeOlusturulmaTarihi),
                }}
            />
        );
    };

    // Helper function to render contract files section
    const renderContractFiles = () => {
        if (!SozlesmeIDContract) return null;

        return (
            <FileViewGoogleDrive
                folderId={GOOGLE_DRIVE_CONTRACT_FILES_FOLDER_ID}
                getOrCreate={true}
                getOrCreateFolderName={SozlesmeIDContract}
                documents={['01_Kabul Edilen Teklif', '02_Satış Sözleşmeleri', '03_Diğer Belgeler']}
                topName={'Sözleşme Dosyaları'}
            />
        );
    };

    if (!SozlesmeIDContract)
        return (
            <MDTypography
                onClick={() => {
                    window.open('https://erp.aaro.com.tr/Sozlesme/Liste?TipID=109001', '_blank');
                }}
                variant="body2"
                color="primary"
                textAlign="center"
            >
                Sözleşme Girilmemiş, lütfen sözleşme oluşturun
            </MDTypography>
        );

    return (
        <>
            <MDBox mb={2}>{renderContractDetails()}</MDBox>
            {/* Sözleşme Dosyaları */}
            <MDBox mb={2}>{renderContractFiles()}</MDBox>
        </>
    );
}

export default SidebarRight;
